import { Address } from '../address';
import { Expertise } from '../expertise';
import { TypeStructure } from '../typeStructure';

export class Employee {
	readonly id: number;
	firstName: string;
	lastName: string;
	email: string;
	username: string;
	address: Address;
	birthDate: string;
	telephone: string;
	statutInt: string
	nomStructure: string;
	typeStructure: TypeStructure;
	expertises: Expertise[];
	addressStructure: Address;
	emailStructure: string;
	phoneStructure: string;
	motDePasseGenere: string;

	constructor(
		options: {
			firstName?: string;
			lastName?: string;
			email?: string;
			address?: Address;
			birthDate?: string;
			telephone?: string;
			nomStructure?: string;
			statutInt?: string;
			typeStructure?: TypeStructure;
			expertises?: Expertise[];
			addressStructure?: Address;
			emailStructure?: string;
			phoneStructure?: string;
		} = {}
	) {
		this.firstName = options.firstName || null;
		this.lastName = options.lastName || null;
		this.email = options.email || null;
		this.address = options.address || new Address();
		//        this.address = options.address || null;
		this.birthDate = options.birthDate || null;
		this.telephone = options.telephone || null;
		this.statutInt = options.statutInt || 'INT';
		this.nomStructure = options.nomStructure || null;
		this.typeStructure = options.typeStructure || null;
		this.addressStructure = options.addressStructure || new Address();
		this.emailStructure = options.emailStructure || null;
		this.phoneStructure = options.phoneStructure || null;
		this.expertises = options.expertises || [];

	}
}
